<template>
	<div id="logout" class="m-top-10">
		<div class="m-top-10 ">
			<h5>确定要退出登录嘛？</h5>
		</div>
		<div class=" m-top-10 text-center hr">
			<button class="btn cancelBtn " @click="cancel">取消</button><button class="btn okBtn" @click="toPage('/login.do')">确定</button>
		</div>
	</div>
</template>

<script>
	import {utils,openlayer,closelayer,confirm} from '../utils/utils'
export default {
	name: 'advancedSearch',
	data() {
		return {}
	},
	mounted() {
		this.oStatus = 1;
	},
	methods: {
		cancel() {
			closelayer();
		},
		toPage(path) {
			var that=this;
			closelayer(0);
			 setTimeout(function() {
			 	sessionStorage.clear();
				that.$router.push({
					path: path
				})
			 },100)	
		}
	}
}
</script>

<style>
#logout{display: none;padding-top: .5rem;}
#logout h5{padding: 0 20px;}
#logout .m-top-10{margin-top: 10px;}
#logout .row{margin-left: 0;margin-right: 0;}
#logout .hr{border-top:1px solid #E6E6E6;padding-top:1.5rem;margin-top:1.5rem;}
#logout .clearData{color: #0793E5;font-size: .8rem;margin-top: .5rem;    display: inline-block;}
#logout .clearData img{width: .8rem;vertical-align: middle;margin-right: .3rem;}
#logout .bginput{width: 70%;}
#logout textarea{width: 100%;height: 100px;padding: 0.56rem 0.75rem;font-size: 0.75rem;}
</style>


// WEBPACK FOOTER //
// src/components/logoutPop-up.vue